import "../../../../styles/page/shoppingCart.scss";

import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";
import { ProductViewListHeader, ProductViewListItem } from "../product/ProductViewListItem.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";
import { Tag, tagTypes } from "../../../common/components/Tag.jsx";
import { countAddedProduct, countOrderLines, countWhat, getProductOrderProperty, getProgressForOrderDate } from "../../util/orderUtil";


import AskMoveUnconfirmedLinesModal from "../../../common/components/AskMoveUnconfirmedLinesModal.jsx";
import Calendar from "../../../common/components/Calendar";
import CounterField from "../../../common/components/CounterField.jsx";
import DeliveringDate from "../deliveringDate.jsx";
import DeliveringStatus from "../deliveringStatus.jsx";
import EmptyShoppingCartList from "./EmptyShoppingCartList.jsx";
import Loading from "../../../common/components/Loading.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import Modal from "../../../common/components/Modal";
import ProgressBar from "../../../common/components/ProgressBar.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll";
import ShoppingCartDetailsModal from "./ShoppingCartDetailsModal.jsx";
import { connect } from "react-redux";
import { getTimeLeftSeconds } from "../../../common/util/time.js";
import moment from "moment";
import { scssVariables } from "../../../common/util/config.jsx";
import { showShoppingCartPdf } from "../../actions/order.js";
import { withRouter } from "react-router-dom";

const mapStateToProps = () => {
    return (state) => ({
        token: state.authentication.token,
    });
};
const mapDispatchToProps = {
    showShoppingCartPdf,
};

/**
 * Returnerar Icon node med icon kod inkluderad
 * 
 * @param {object} props
 * @returns {node}
 */
function CalenderDropdown({setDropDown, dropDown, localization, date, validDates, previousDates, nextOrderDate, onSelectDate, deliveryDates, newSeasonDistrDates}) {
    /**
     * selects the date and hides the dropdown window
     * 
     * @param {object} date
     * @returns {undefiend}
     */
    function onClick(date) {
        setDropDown(null);
        onSelectDate(date);
    }
    return (
        <Calendar localization={localization} dropDown={dropDown} date={date} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={onClick} deliveryDates={deliveryDates} newSeasonDistrDates={newSeasonDistrDates}/>
    );
}
CalenderDropdown.propTypes = {
    setDropDown: PropTypes.func,
    date: PropTypes.string,
    dropDown: PropTypes.bool,
    nextOrderDate: PropTypes.string,
    onSelectDate: PropTypes.func,
    previousDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    validDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    localization: Localization.propTypes.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    newSeasonDistrDates: PropTypes.array.isRequired,
};

/**
 * A counter designed for ordered items
 * 
 * @param {object} props
 * @returns {node}
 */
function CounterOrdered({product, list, counting, sLeft, disabled, addRemoveProductToTemporaryOrder, salesLineId}) {
    /**
     * sends the canges
     * 
     * @param {object} change
     * @returns {undefiend}
     */
    function onClick(change) {
        addRemoveProductToTemporaryOrder(product, change.value, change.salesLineId);
    }
    
    const addedCount = countAddedProduct(list, product.productId, counting, salesLineId);
    const minValue = getProductOrderProperty(list, product.productId, "mustOrderAtLeastOne", salesLineId)?1:0;
    const isLocked = getProductOrderProperty(list, product.productId, "isLocked", salesLineId) || getProductOrderProperty(list, product.productId, "isKitMember", salesLineId);
    const changed =  list.unConfirmedOrderLines && list.unConfirmedOrderLines.some( (item) => item.product.productId===product.productId && item.salesLineId === salesLineId && salesLineId>0);

    return (
        <CounterField changed={changed} onEdit={onClick} value={addedCount} canChangeValue={!disabled} salesLineId={salesLineId} border={false} disabled={isLocked || sLeft==0} invisibleBackground={true} alwaysShowInputField={true} minValue={minValue}/>
    );
}
CounterOrdered.propTypes = {
    product: PropTypes.object,
    list: PropTypes.object,
    counting: PropTypes.string,
    addRemoveProductToTemporaryOrder: PropTypes.func,
    sLeft: PropTypes.number,
    disabled: PropTypes.bool,
    salesLineId: PropTypes.number,
};

class ShoppingCart extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            expanded: this.props.deviceType!=="xs" || this.props.lastOrder,
            askToMoveItems: false,
            sortChangedFirst: false,
        };

        this.getDropDownDateStyle = this.getDropDownDateStyle.bind(this);

        this.onCloseModal = this.onCloseModal.bind(this);
        this.onMoveToNextOrder = this.onMoveToNextOrder.bind(this);
        this.onSelectDate = this.onSelectDate.bind(this);
        this.onClickShowFee = this.onClickShowFee.bind(this);
        this.onClickShowPdf = this.onClickShowPdf.bind(this);
        this.onClickShowCartModal = this.onClickShowCartModal.bind(this);
        
        this.calculateListHeight = this.calculateListHeight.bind(this);
        this.onClickExpand = this.onClickExpand.bind(this);
        this.onClickMinimize = this.onClickMinimize.bind(this);
        this.prepareShoppingCart = this.prepareShoppingCart.bind(this);

        this.hasErrorLines = this.hasErrorLines.bind(this);
        this.hasWarningLines = this.hasWarningLines.bind(this);

        this.checkTimeForLocking = this.checkTimeForLocking.bind(this);
        this.onSortChanged = this.onSortChanged.bind(this);
    }
    componentDidMount() {
        this.interval = setInterval(this.checkTimeForLocking, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    checkTimeForLocking() {
        const {
            activeOrder,
            localization,
            deliveryDates,
            setModal,
            moveUnconfirmedLinesToNextOrder,
        } = this.props;
        const sLeft = getTimeLeftSeconds(this.props.activeOrder.customerDeadlineDate);
        if( sLeft===0){
            //next line forces a re-render, the data is not used
            this.setState({
                cartLocked: true,
            });
            if( this.props.activeOrder.unConfirmedOrderLines && this.props.activeOrder.unConfirmedOrderLines.length>0 ) {
                setModal(<AskMoveUnconfirmedLinesModal  localization={localization} setModal={setModal} oldUnconfirmedOrderLineCount={activeOrder.unConfirmedOrderLines.length} deliveryDates={deliveryDates} orderLocked={true} moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder} onCloseModal={this.onCloseModal}/>);                
            }
            //makes sure that no more re-renders happens
            clearInterval(this.interval);
        }
    }

    getDropDownDateStyle() {
        const {
            width,
            deviceType,
        } = this.props;

        //calender max current max size is 450
        return (deviceType==="xs" && {
            width: Math.min(450, Math.max(parseInt(scssVariables.minDeviceWidth),width)),
        }) || (deviceType==="sm" && {
            width: Math.min(450,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin)+parseInt(scssVariables.menuHeight)),
        } || {
            width: 450,
        });
    }

    onSelectDate(date) {
        const {
            deliveryDates,
            setActiveOrder,
        } = this.props;
        for(let i=0; i<deliveryDates.length; i++){
            if( moment(deliveryDates[i].deliveryDate).format("YYYY-MM-DD")==date ){
                setActiveOrder(deliveryDates[i].shipmentId, deliveryDates[i].distributionRouteId, deliveryDates[i].deliveryDate);
            }
        }
    }
    onClickShowFee(){
        const {
            deviceType,
            activeOrder,
            localization,
            orderFeeLimits,
            orderVolumeDiscounts,
        } = this.props;
        const isTinyDevice = deviceType==="xs" || deviceType==="sm";
        const orderSize = countOrderLines(activeOrder);
        const orderFeeOrDiscount = activeOrder.orderFee || activeOrder.orderDiscount || 0;
        const totalCost = activeOrder.sumExVat || 0;
        const baseAmountOrderFee = activeOrder.baseAmountOrderFee || 0;
        const nodes = [];
        const discountNodes = [];
        const activeFeeIndex = orderFeeLimits.findIndex( (item) => item.orderSum>=baseAmountOrderFee);
        for(let i=0; i<=orderFeeLimits.length; i++){
            nodes.push(
                <div className={`grid-row ${i===orderFeeLimits.length?"bottom":"middle"} ${(activeFeeIndex===-1?orderFeeLimits.length:activeFeeIndex)===i?"bold":""}`} key={i}>
                    <div className="grid-col">
                        {i==0?<>{"<"}{orderFeeLimits[i].orderSum}</>:(i<orderFeeLimits.length?<>{`${orderFeeLimits[i-1].orderSum}-${orderFeeLimits[i].orderSum}`}</>:<>{orderFeeLimits[i-1].orderSum}{">"}</>)}
                    </div>
                    <div className="grid-col">
                        {i<orderFeeLimits.length?`kr ${orderFeeLimits[i].fee.toFixed(2)}`:"Fri gebyr"}
                    </div>
                </div>
            );
        }

        if(orderVolumeDiscounts.length > 0) {
            for(let i=0; i<=orderVolumeDiscounts.length; i++){
                discountNodes.push(
                    <div className={`grid-row ${i===orderVolumeDiscounts.length?"bottom":"middle"} ${(activeFeeIndex===-1?orderVolumeDiscounts.length:activeFeeIndex)===i?"bold":""}`} key={i}>
                        <div className="grid-col">
                            {i==0?<>{"<"}{orderVolumeDiscounts[i].orderSum}</>:(i<orderVolumeDiscounts.length?<>{`${orderVolumeDiscounts[i-1].orderSum}-${orderVolumeDiscounts[i].orderSum}`}</>:<>{orderVolumeDiscounts[i-1].orderSum}{">"}</>)}
                        </div>
                        <div className="grid-col">
                            {i>0 ?`-${orderVolumeDiscounts[i-1].discountPercent.toFixed(2)} %`:"Ingen rabatt"}
                        </div>
                    </div>
                );
            }
        }
        
        this.props.setModal(
            <Modal onCloseModal={this.onCloseModal}>
                <div className="modal-wrapper" style={{width:isTinyDevice?320:475}}>
                    <div className="header">
                        <div className="header-left">
                            <div className="header-detail">{localization.text("order","gebyrModal","header")}</div>
                        </div>
                        <button className="btn circular" style={{float:"right"}} onClick={this.onCloseModal}>
                            <Icon type={iconTypes.x} color={iconColor.red}/>
                        </button>
                    </div>
                    <div className="body bottom-border">
                        <div className="gebyr-grid">
                            <div className="grid-header">
                                <div className="header-col">
                                    {localization.text("order","gebyrModal","priceRange")}
                                </div>
                                <div className="header-col">
                                    {localization.text("order","gebyrModal","fee")}
                                </div>
                            </div>
                            {nodes}
                        </div>
                    </div>
                    {discountNodes.length > 0 && (
                        <div className="body bottom-border">
                            <div className="gebyr-grid">
                                <div className="grid-header">
                                    <div className="header-col">
                                        {localization.text("order","gebyrModal","priceRange")}
                                    </div>
                                    <div className="header-col">
                                        {localization.text("order","gebyrModal","discount")}
                                    </div>
                                </div>
                                {discountNodes}
                            </div>
                        </div>)
                    }

                    <div className="footer">
                        <div className="shopping-cart-menu-info">
                            <Icon type={iconTypes.boxOpen} style={{marginLeft:"9px"}}/>
                            <div className="label16 shopping-cart-menu-info-text flex-align-center">
                                {localization.text("order","inYourOrder")}
                            </div>
                            {this.hasWarningLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.warning} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","warningTooltip")}</span>
                                </div>
                            )}
                            {this.hasErrorLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.error} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","errorTooltip")}</span>
                                </div>
                            )}
                            <div className="flex-align-center">
                                { orderSize>0 ? (
                                    <Tag type={tagTypes.red} label={localization.text("order","countLines",{count:orderSize})}/>
                                ) : (
                                    <Tag type={tagTypes.grey} label={localization.text("order","empty")} className={"tag-large"}/>
                                )}
                            </div>
                        </div>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={4} sm={2}>
                                <div className="shopping-cart-info-header">
                                    {localization.text("order", "deliveryFee")}
                                </div>
                                <div className="shopping-cart-info-price">{orderFeeOrDiscount.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "feeBase")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{baseAmountOrderFee.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "total")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{totalCost.toFixed(2)}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            </Modal>
        );
    }
    onCloseModal() {
        this.props.setModal(null);
    }
    onClickShowPdf() {
        const {
            activeOrder,
            showShoppingCartPdf,
            token,
        } = this.props;

        const data = {
            shipmentId: activeOrder.shipmentId,
            distributionRouteId: activeOrder.distributionRouteId,
            deliveryDate: activeOrder.deliveryDate,
        };

        showShoppingCartPdf(data, token);
    }
    onClickShowCartModal() {
        const {
            localization,
            setActiveOrder,
            flowControl,
            showShoppingCartPdf,
            token,
        } = this.props;

        this.props.setModal(
            <ShoppingCartDetailsModal 
                setActiveOrder={setActiveOrder}
                localization={localization} 
                onCloseModal={this.onCloseModal} 
                hasWarningLines={this.hasWarningLines} 
                hasErrorLines={this.hasWarningLines}  
                prepareShoppingCart={this.prepareShoppingCart}
                flowControl={flowControl}
                showShoppingCartPdf={showShoppingCartPdf}
                token={token}
            />);
    }
    onMoveToNextOrder() {
        this.setState({
            askToMoveItems: false,
        });
        this.props.moveUnconfirmedLinesToNextOrder();
        this.props.setModal(null);
    }

    onClickExpand() {
        this.setState({
            expanded: true,
        });

        if(this.props.editQueryFilter)
        {
            this.props.editQueryFilter({
                searchString: ""
            });   
        }  
    }
    onClickMinimize() {
        this.setState({
            expanded: false,
        });
    }

    calculateListHeight() {
        const {
            height,
        } = this.props;

        let listHeight = height;

        //top menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //progressbar
        listHeight -= parseInt(scssVariables.progresbarHeight);
        //second menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //bottom section
        listHeight -= parseInt(scssVariables.shoppingCartDetailHeight);

        return listHeight;
    }

    prepareShoppingCart(disabled) {
        const {
            deviceType,
            localization,
            addRemoveProductToTemporaryOrder,
            activeOrder,
            setModal,
            lastOrder,
        } = this.props;

        const retNodes = [];
        //shopping cart exist only in 2 sizes 320px($shopping-cart-width-tiny) or 465px($shopping-cart-width)
        const renderedForDeviceType = (deviceType==="xs" || deviceType==="sm") ? "xs" : "sm";

        const sLeft = getTimeLeftSeconds(activeOrder.customerDeadlineDate);

        const createProductViewListItem = (keyStart, line, index, counting) => (
            <ProductViewListItem
                key={`${keyStart}-${line.productId}-${index}`}
                localization={localization}
                product={line.product || {}}
                deviceType={renderedForDeviceType}
                addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                counting={counting}
                list={activeOrder}
                border={false}
                disabled={disabled || sLeft==0}
                setModal={setModal}
                salesLineId={line.salesLineId}
                countingNode={<CounterOrdered product={line.product ||{}} list={activeOrder} sLeft={sLeft} addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder} counting={counting} minValue={line.mustOrderAtLeastOne?1:0} salesLineId={line.salesLineId}/>}
            />
        );

        //filter out all with warnings/errors
        const storageQtyLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.lowQtyForStorageTypes!=="" ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.lowQtyForStorageTypes!=="" ) || [] );

        const unConfirmedLines = activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) =>
            line.warningText==null && line.errorText==null && line.lowQtyForStorageTypes==="") || [];

        const unConfirmedNewLines = unConfirmedLines.filter( (line) => line.salesLineId === 0);
        // const unConfirmedUpdatedLines = unConfirmedLines.filter( (line) => line.salesLineId === 0);


        if( (unConfirmedNewLines.length > 0 || storageQtyLines.length > 0) && !lastOrder) {
            const storageText = storageQtyLines.length>0 ? `${localization.text("order","lowQtyStorageTypeTag")} ${storageQtyLines[0].lowQtyForStorageTypes}` : "";
            const unconfirmedText = unConfirmedNewLines.length>0 ? `${localization.text("order","unconfirmed")}${storageQtyLines.length>0 ? " / ": ""}` : "";
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"unconfirmed"} ><Tag type={tagTypes.red} label={unconfirmedText + storageText} /></div>);            
            if(unConfirmedNewLines.length > 0)  retNodes.push(...unConfirmedNewLines.map( (line, index) => createProductViewListItem("Un", line, index, countWhat.unConfirmed) ));
            if(storageQtyLines.length > 0) retNodes.push(...storageQtyLines.map( (line, index) => createProductViewListItem("Un", line, index, countWhat.everything) ));
        }
        //list all with warnings
        const warningLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.warningText!=null && line.errorText==null &&  line.lowQtyForStorageTypes==="" ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.warningText!=null && line.errorText==null &&  !line.lowQtyForStorageTypes ) || [] );
        if( warningLines.length>0 ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"warnings"} ><Tag type={tagTypes.red} label={localization.text("order","warningTag")} /></div>);
            retNodes.push(...warningLines.map( (line, index) => createProductViewListItem("Wa", line, index, countWhat.everything) ));
        }
        //list all with errors
        const errorLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.errorText!=null ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.errorText!=null ) || [] );
        if( errorLines.length>0 ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"errors"} ><Tag type={tagTypes.red} label={localization.text("order","errorTag")} /></div>);
            retNodes.push(...errorLines.map( (line, index) => createProductViewListItem("Er", line, index, countWhat.everything) ));
        }

        //We want to filter out all lines that appears in unordered, or have error or warning message
        const confirmedLines = activeOrder.orderLines && activeOrder.orderLines.filter( 
            (line) => line.warningText==null && line.errorText==null);
            //&& !(activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.find( (item) => item.product.productId===line.productId && item.salesLineId === line.salesLineId) || false));
        
        const confirmedLinesUpdatedWithUnconfirmed = confirmedLines.map(line => { 
            const existing = unConfirmedLines.find( (item) => item.product.productId===line.productId && item.salesLineId === line.salesLineId);
            return existing ? existing : line;
        });

        const updatedLines = confirmedLines.filter(line => 
            unConfirmedLines.some( (item) => item.product.productId===line.productId && item.salesLineId === line.salesLineId)
        );
        const unchangedLines = confirmedLines.filter(line => 
            !unConfirmedLines.some( (item) => item.product.productId===line.productId && item.salesLineId === line.salesLineId)
        );
        const confirmedLinesUpdatedWithUnconfirmedSorted = this.state.sortChangedFirst ? updatedLines.concat(unchangedLines) : confirmedLinesUpdatedWithUnconfirmed;

        if( confirmedLinesUpdatedWithUnconfirmedSorted ){
            retNodes.push(<div className="shopping-cart-list-splitter-ordered" key={"ordered"} >
                <Tag type={tagTypes.green} label={localization.text("order","ordered")} /> 
                <Tag type={tagTypes.grey} className={`shopping-cart-button-tag ${renderedForDeviceType}`} label={this.state.sortChangedFirst ? "Fjern Sortering": "Sortere"} onClickTag={this.onSortChanged} /></div>);
            retNodes.push(...confirmedLinesUpdatedWithUnconfirmedSorted.map( (line, index) => createProductViewListItem("Or", line, index, countWhat.everything) ));
        }

        return retNodes;
    }

    onSortChanged() 
    {
        this.setState({
            sortChangedFirst: !this.state.sortChangedFirst,
        });
    }

    hasErrorLines() {
        const {activeOrder} = this.props;
        const errorLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.errorText!=null ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.errorText!=null ) || [] );
        return errorLines.length>0;
    }
    hasWarningLines() {
        const {activeOrder} = this.props;
        const warningLines = (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.filter( (line) => line.warningText!=null ) || [])
            .concat( activeOrder.orderLines && activeOrder.orderLines.filter( (line) => line.warningText!=null ) || [] );
        return warningLines.length>0;
    }

    render(){
        const {
            activeOrder,
            localization,
            height,
            deviceType,
            submitOrder,
            deliveryDates,
            setDropDown,
            lastOrder,
            newSeasonDistrDates,
        } = this.props;
        const {
            expanded
        } = this.state;

        const listHeight = this.calculateListHeight();

        const isTinyDevice = deviceType==="xs" || deviceType==="sm";
        const isMobile = deviceType==="xs";

        const deliveredDate = activeOrder.deliveryDate ? moment(activeOrder.deliveryDate).format("MMM DD") : "--- --";
        const deliveryTime = activeOrder.deliveryDate ? moment(activeOrder.deliveryDate).format(`[${localization.text("time","at")}] HH:mm`) : "--:--";
        const orderSize = countOrderLines(activeOrder);
        const orderFeeOrDiscount = activeOrder.orderFee || activeOrder.orderDiscount || 0;
        const totalCost = activeOrder.sumExVat || 0;
        const baseAmountOrderFee = activeOrder.baseAmountOrderFee || 0;
        //
        const nextOrderDate = deliveryDates && deliveryDates.length>0 ? moment(deliveryDates[0].deliveryDate).format("YYYY-MM-DD") : "";
        const workingDate = moment(activeOrder.deliveryDate).format("YYYY-MM-DD");
        const previousDates = [];
        const validDates = deliveryDates ? deliveryDates.map(item => {
            return moment(item.deliveryDate).format("YYYY-MM-DD");
        }) : [];

        //linear percentage from 24h left on the clock
        const sLeft = getTimeLeftSeconds(activeOrder.customerDeadlineDate);
        const progress = getProgressForOrderDate(activeOrder.customerDeadlineDate);

        //An order can only be updated if not submitting anything, and there is still time left on the clock
        const canWorkWithOrder = !activeOrder.submitting && sLeft>0;
        //An order can only be sentIn if not loading/submitting anything, and there is unConfirmedOrderLines and there is still time left on the clock
        const canSendInOrder = !activeOrder.loading && !activeOrder.submitting && (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.length || 0)>0 && sLeft>0;

        const renderCart = () => {
            return (
                <React.Fragment>
                    <SubMenu>
                        {!lastOrder && (
                            <React.Fragment>
                                <SubMenuItem roundCornerTopLeft={true} iconType={iconTypes.calender} setDropDown={setDropDown} dropDownStyle={this.getDropDownDateStyle()} dropDownShiftLeft={deviceType!=="xs"} isDroppedDown={true} below={true} dropDownChildren={(
                                    <CalenderDropdown localization={localization} dropDown={true} date={workingDate} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={this.onSelectDate} setDropDown={setDropDown} deliveryDates={deliveryDates} newSeasonDistrDates={newSeasonDistrDates}/>
                                )}/>
                                <div className="shopping-cart-calendar-text">
                                    {localization.text("dashboard","calendar")}
                                </div>   
                            </React.Fragment>
                        )}                       
                        <SubMenuItem interactive={false}>
                            <div className="shopping-cart-menu-item-date">
                                <DeliveringDate localization={localization} deliveryDate={deliveredDate} deliveryTime={deliveryTime} useIcon={true} />
                            </div>
                        </SubMenuItem>
                        <SubMenuItem interactive={false} side="left-borderless">
                            <div className="shopping-cart-menu-item-status">
                                <DeliveringStatus localization={localization} isDelivered={false} deadlineDate={activeOrder.customerDeadlineDate} fontSize={16} showIcon={!isTinyDevice}/>
                            </div>
                        </SubMenuItem>
                       
                        {!isMobile && lastOrder && (                  
                            <button className="btn circular" style={{float: "right", marginTop:"10px", marginLeft:"10px", marginRight:"10px"}} onClick={this.onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red}/>
                            </button>
                        )}  
                        
                        {isTinyDevice || lastOrder ?(
                            <button className="btn img" style={{marginTop:"10px", marginLeft:"0px", border: "0px",  right: isMobile? "40px" : "0px", float: "right" }} onClick={this.onClickShowPdf}>
                                <Icon type={iconTypes.print}></Icon>
                            </button>  
                        ):(
                            <button className="btn circular" style={{marginTop:"10px", marginLeft:"10px", marginRight:"10px", float:"right" }} onClick={this.onClickShowCartModal}>
                                <Icon type={iconTypes.print}></Icon>
                            </button>  
                        )}

                        {/* <SubMenuItem onClick={this.onClickShowPdf} style={{marginLeft:"-10px"}} iconType={iconTypes.print} /> */}
                        {isMobile && (
                            <SubMenuItem side="locked-right" flex={true} style={{marginTop:"10px"}} onClick={this.onClickMinimize} iconType={iconTypes.down} />
                        )}
                    </SubMenu>
                    <ProgressBar progress={progress}/>
                    <div className="sub-menu border flex-align-center">
                        <div className="shopping-cart-menu-info">
                            <Icon type={iconTypes.boxOpen} style={{marginLeft:"9px"}}/>
                            <div className="label16 shopping-cart-menu-info-text flex-align-center">
                                {localization.text("order","inYourOrder")}
                            </div>
                            {this.hasWarningLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.warning} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","warningTooltip")}</span>
                                </div>
                            )}
                            {this.hasErrorLines() && (
                                <div className="tooltip">
                                    <Icon type={iconTypes.error} />
                                    <span className="tooltiptext" style={{width:"180px",marginLeft:"-90px"}}>{localization.text("order","errorTooltip")}</span>
                                </div>
                            )}
                            <div className="flex-align-center">
                                { orderSize>0 ? (
                                    <Tag type={tagTypes.red} label={localization.text("order","countLines",{count:orderSize})}/>
                                ) : (
                                    <Tag type={tagTypes.grey} label={localization.text("order","empty")} className={"tag-large"}/>
                                )}
                            </div>
                        </div>
                    </div>
                    {orderSize>0? (
                        <React.Fragment>
                            <div className={"product-view-header-wrapper"} >
                                <ProductViewListHeader localization={localization} deviceType={isTinyDevice?"xs":"sm"}/>
                            </div>
                            <Scroll style={{height: listHeight-34, width:"100%", opacity:sLeft===0?0.5:undefined}}>
                                {this.prepareShoppingCart(!canWorkWithOrder)}
                            </Scroll>
                        </React.Fragment>
                    ) : (
                        activeOrder.loading ? (
                            <Loading height={listHeight} width="100%" loadingSize={30} points={12} lapTime={2}/>
                        ) : ( activeOrder.shipmentId!=null ? (
                            <EmptyShoppingCartList listHeight={listHeight} localization={localization}/>
                        ) : (
                            <div style={{height:listHeight}}></div>
                        ))
                    )}
                    <div className="shopping-cart-bottom">
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                {baseAmountOrderFee>1 && activeOrder.nextOrderFeeLevel ? (
                                    <button className="btn-tiny primary" style={{width:"100%"}} onClick={this.onClickShowFee}>
                                        {localization.text("order","addForXTolowerFee",{value:activeOrder.amountToNextFeeLevel})}
                                    </button>
                                ) : baseAmountOrderFee>1 && activeOrder.nextOrderDiscountLevel ? (
                                    <button className="btn-tiny primary" style={{width:"100%"}} onClick={this.onClickShowFee}>
                                        {localization.text("order","addForXToIncreaseDiscount",{value:activeOrder.amountToNextDiscountLevel})}
                                    </button>
                                ) :
                                    (
                                        <button className="btn-tiny primary" style={{width:"100%"}} onClick={this.onClickShowFee}>
                                            {localization.text("order","gebyrInfo")}
                                        </button>
                                    )}
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={4} sm={3}>
                                <div className="shopping-cart-info-header">
                                    {localization.text("order", "deliveryFee")}
                                </div>
                                <div className="shopping-cart-info-price">{orderFeeOrDiscount.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4} sm={5}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "feeBase")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{baseAmountOrderFee.toFixed(2)}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="shopping-cart-info-header-bold">
                                    {localization.text("order", "total")}
                                </div>
                                <div className="shopping-cart-info-price-bold">{totalCost.toFixed(2)}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                {isTinyDevice ? (
                                    <>
                                        {!lastOrder &&(
                                            <button className={"btn primary block"} onClick={submitOrder}  disabled={!canSendInOrder}>
                                                { activeOrder.orderLines && activeOrder.orderLines.length>0 ? localization.text("order", "reSubmitOrder") : localization.text("order", "submitOrder")}
                                            </button>
                                        )}                                       
                                    </> 
                                ) : (
                                    <>
                                        <div className="last-submit">
                                            { activeOrder.lastSubmittedDate && localization.text("order", "lastUpdated",{date:moment(activeOrder.lastSubmittedDate).format("YYYY-MM-DD HH:mm")}) }
                                        </div>
                                        {!lastOrder && (
                                            <button className={"btn primary"} onClick={submitOrder}  disabled={!canSendInOrder}>
                                                { activeOrder.orderLines && activeOrder.orderLines.length>0 ? localization.text("order", "reSubmitOrder") : localization.text("order", "submitOrder")}
                                            </button>
                                        )}                                       
                                    </>
                                )}
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </React.Fragment>
            );
        };

        return expanded ? (
            deviceType==="xs" ? (
                <React.Fragment>
                    <div className="dim-screen" onClick={ lastOrder ? this.onCloseModal : this.onClickMinimize}/>
                    <div className={lastOrder ? "shopping-cart-card-expanded-tiny-lastorder" : "shopping-cart-card-expanded-tiny"} style={{height:`${height+parseInt(scssVariables.cardMargin)}px`}}>
                        {renderCart()}
                    </div>
                </React.Fragment>
            ) : (
                <div className="card-default shopping-cart-card" style={{height:`${height}px`}}>
                    {renderCart()}
                </div>
            )
        ) : (
            <div className="shopping-cart-card-tiny">
                <SubMenu>                   
                    <React.Fragment>
                        <SubMenuItem iconType={iconTypes.calender} dropDownStyle={this.getDropDownDateStyle()} setDropDown={setDropDown} isDroppedDown={false} below={false} dropDownShiftLeft={false} dropDownChildren={(
                            <CalenderDropdown localization={localization} date={workingDate} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={this.onSelectDate} setDropDown={setDropDown} deliveryDates={deliveryDates} newSeasonDistrDates={newSeasonDistrDates} />
                        )}/>
                        <div className="shopping-cart-calendar-text">
                            {localization.text("dashboard","calendar")}
                        </div>   
                    </React.Fragment>
                    <SubMenuItem interactive={false}>
                        <div className="shopping-cart-menu-item-date">
                            <DeliveringDate localization={localization} deliveryDate={deliveredDate} deliveryTime={deliveryTime} useIcon={true} />
                        </div>
                    </SubMenuItem>
                    <SubMenuItem interactive={false} side="left-borderless">
                        <div className="shopping-cart-menu-item-status">
                            <DeliveringStatus localization={localization} isDelivered={false} deadlineDate={activeOrder.customerDeadlineDate} fontSize={16} showIcon={!isTinyDevice}/>
                        </div>
                    </SubMenuItem>
                    <SubMenuItem iconType={iconTypes.up} side="locked-right" onClick={this.onClickExpand} />
                </SubMenu>
            </div>
        );
    }
}

ShoppingCart.propTypes = {
    localization: Localization.propTypes.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func,
    activeOrder: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number,
    submitOrder: PropTypes.func,
    deliveryDates: PropTypes.array,
    setActiveOrder: PropTypes.func,
    moveUnconfirmedLinesToNextOrder: PropTypes.func,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func,
    orderFeeLimits: PropTypes.array.isRequired,
    orderVolumeDiscounts: PropTypes.array.isRequired,
    lastOrder: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    showShoppingCartPdf: PropTypes.func.isRequired,
    newSeasonDistrDates: PropTypes.array,
    editQueryFilter: PropTypes.func,
    flowControl: PropTypes.func.isRequired,
};

//export default ShoppingCart;
export default  withRouter(connect(mapStateToProps,mapDispatchToProps)(ShoppingCart));